var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.44 575.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .accent {\n        fill: #e88324;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M317.29,592.49c0,.4,0,.81,0,1.21,0,0-127.51,6.2-165.57-14.11C100,552,131.87,426.76,131.87,426.76A277.86,277.86,0,0,0,317.29,592.49Z",
    transform: "translate(-99.95 -18.74)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M653.31,529.07a63.9,63.9,0,0,1-63.92,64.65H469.78c0-1.12,0-2.23-.08-3.33A277.88,277.88,0,0,0,646.64,429.3C651.24,443.84,652.83,489.54,653.31,529.07Z",
    transform: "translate(-99.95 -18.74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M607.34,106.54C680.37,179.57,671,308,671,308s-116.5-2.57-189.53-75.6S377.42,72,412.18,37.24,534.31,33.51,607.34,106.54Z",
    transform: "translate(-99.95 -18.74)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M290.75,236.33C213.42,304.78,100,308,100,308s-4.56-136.5,72.78-205,166.43-94.1,199-57.3S368.09,167.88,290.75,236.33Z",
    transform: "translate(-99.95 -18.74)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M280.35,37.66S374.15,6.81,465.08,23.9,475,162,475,162L400,97.31,474,203,379.21,98.37Z",
    transform: "translate(-99.95 -18.74)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M379.21,98.37S387.08,141,430,165.5,458,119,458,119Z",
    transform: "translate(-99.95 -18.74)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "accent",
    d: "M100,308s85,30.22,130-32.39",
    transform: "translate(-99.95 -18.74)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair2);
export default __webpack_public_path__ + "static/media/hair2.00547f9c.svg";
export { ForwardRef as ReactComponent };